module.exports = __webpack_public_path__ + "media/images/piscine-pv-e780fd2575f4470b4d525cdaad91260e.svg";